import { datadogRum } from "@datadog/browser-rum";

const init = (): void => {
  if (process.env.REACT_APP_ENV !== 'local') {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.com",
      service: "qisign",
      env: process.env.REACT_APP_ENV,
      version: "1.0.0",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "allow",
      beforeSend: (event, __context) => {
        if (event.type === 'error' && event.error.message) {
            const message = event.error.message;
            const suppressedErrorSignatures = [
                'Script error.',
                'Created TensorFlow Lite XNNPACK delegate for CPU',
                'Provided "OCR error occurred"',
                'Provided "Device error occurred"',
                'Provided "Face recognition error occurred"',
                `undefined is not an object (evaluating '_0x4d1ef2`,
                'wasm streaming compile',
                'falling back to ArrayBuffer',
                'async and sync fetching of the wasm failed',
                'No full support of FP16 on this GPU',
                'Check failed: prod_token',
                'CalculatorGraph::Run() failed',
                'gl_graph_runner_internal_image.cc',
                "Aborted",
            ];
            const shouldSuppress = suppressedErrorSignatures.some(
                signature => message.includes(signature)
            );
            if (shouldSuppress) {
                setDatadogAction('Supressed an error during execution', event);
                return false; 
            }
        }
        return true;
      },
    });

    datadogRum.startSessionReplayRecording();
  }
};

export function setUserInDatadog(id: string, name: string, email: string) {
  datadogRum.setUser({
    id,
    name,
    email,
  });
}

export function setDatadogError(error: any, context: any) {
  if (process.env.REACT_APP_ENV !== 'local') {
    datadogRum.addError(error, context);
  } else {
    console.error('setDatadogError', error, context);
  }
}

export function setGlobalContext(context: any) {
  if (process.env.REACT_APP_ENV !== 'local') {
    datadogRum.setGlobalContext(context);
  } else {
    console.log('setGlobalContext', context);
  }
}


export function setDatadogPageAction(page: string, context: any) {
  if (process.env.REACT_APP_ENV !== 'local') {
    datadogRum.addAction(page + ' has been loaded', context);
  }
}

export function setDatadogAction(action: string, context: any) {
  if (process.env.REACT_APP_ENV !== 'local') {
    datadogRum.addAction(action, context);
  } else {
    console.log('setDatadogAction', action, context);
  }
}

export const DataDogService = {
  init,
};
